import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-domestic-violence-form',
  templateUrl: './domestic-violence-form.component.html',
  styleUrls: ['./domestic-violence-form.component.scss']
})
export class DomesticViolenceFormComponent implements OnInit {
	domesticViolenceForm: FormGroup;
  @Output() hasValidDomesticViolence = new EventEmitter<boolean>();
	@Output() data = new EventEmitter();
	constructor(private _formBuilder: FormBuilder) { }

	ngOnInit(): void {
    this.domesticViolenceForm = this._formBuilder.group({
      HasDomesticViolence: [null, [Validators.required]],
      HasRestrainingOrder: [null],
      PoliceCalled: [null],
      PoliceInvolvedTime: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      HasArrest: [null],
      IsCurrentlyInShelter: [null],
      IsRequestSession: [null],
      IsWithSupportPerson: [null]
		})
    this.hasValidDomesticViolence.emit(this.domesticViolenceForm.valid);
    this.domesticViolenceForm.statusChanges.subscribe((res) => {
      this.hasValidDomesticViolence.emit(this.domesticViolenceForm.valid);
		})
    this.domesticViolenceForm.valueChanges.subscribe(res => {
			this.data.emit(res);
    })

    this.domesticViolenceForm.get('PoliceCalled').valueChanges.subscribe((value) => {
      this.togglePoliceTimes(value);
    });
  }

  private togglePoliceTimes(PoliceCalled: string): void {
    const policeTimesControl: AbstractControl = this.domesticViolenceForm.get('PoliceInvolvedTime');

    if (PoliceCalled === 'true') {
      policeTimesControl.enable();
      policeTimesControl.setValidators([Validators.required, Validators.pattern(/^(0|[1-9]\d*)$/)]);
    } else {
      policeTimesControl.disable();
      policeTimesControl.reset();
    }

    policeTimesControl.updateValueAndValidity();
  }
}
